module.exports = __webpack_public_path__ + "static/media/img33.fea34a00.jpg";